import { rerenderLayout } from "@/store/RenderProtectionRoute.slice";
import { Check, X } from "lucide-react";
import { useEffect, useState, MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

function PaymentStatus() {
  const { t } = useTranslation();
  const location = useLocation();
  const [status, setStatus] = useState<"success" | "failed" | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.has("subscription-payment-success")) {
      setStatus("success");
      setIsVisible(true);
    } else if (searchParams.has("subscription-payment-failed")) {
      setStatus("failed");
      setIsVisible(true);
    } else if (searchParams.has("branches-increase-payment-success")) {
      setStatus("success");
      setIsVisible(true);
    } else if (searchParams.has("branches-increase-payment-failed")) {
      setStatus("failed");
      setIsVisible(true);
    }

    if (
      searchParams.has("subscription-payment-success") ||
      searchParams.has("subscription-payment-failed") ||
      searchParams.has("branches-increase-payment-success") ||
      searchParams.has("branches-increase-payment-failed")
    ) {
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.delete("subscription-payment-success");
      newSearchParams.delete("subscription-payment-failed");
      newSearchParams.delete("branches-increase-payment-success");
      newSearchParams.delete("branches-increase-payment-failed");

      const newUrl =
        window.location.pathname +
        (newSearchParams.toString() ? `?${newSearchParams.toString()}` : "");

      window.history.replaceState({}, "", newUrl);
    }
  }, [location]);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setIsVisible(false), 5000);
      dispatch(rerenderLayout())
      return () => clearTimeout(timer);
    }
  }, [dispatch, isVisible]);

  const closeModal = () => setIsVisible(false);

  const handleOverlayClick = () => closeModal();

  const handleModalClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  if (!isVisible || !status) return null;

  const Icon = status === "success" ? Check : X;
  const iconColor = status === "success" ? "bg-green-500" : "bg-red-500";

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50"
      onClick={handleOverlayClick}
    >
      <div
        className="w-full max-w-[90%] rounded-lg bg-white p-6 py-16 shadow-lg sm:max-w-md"
        onClick={handleModalClick}
      >
        <div className="flex flex-col items-center text-center">
          <div className={`rounded-full ${iconColor} p-4`}>
            <Icon className="h-16 w-16 text-white" />
          </div>
          <h2 className="mt-4 text-2xl font-semibold">
            {status === "success"
              ? t("subscribtionSettings.paymentSuccessMessage")
              : t("subscribtionSettings.paymentFailedMessage")}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default PaymentStatus;
